exports.default = {
  'invite_title': '邀請朋友得積分',
  'invite_subtitle': '每次成功邀請雙方均可 {points} 積分。',
  'share_web': '網頁分享',
  'share_mobile': '移動端分享',
  'invite_code_label': '邀請碼',
  'copy_link': '複製邀請鏈接',
  'invite_facebook': 'Facebook 邀請',
  'invitations': '邀請記錄',
  'credits': '積分',
  'referrals': '邀請人數',
  'history_title': '邀請歷史',
  'anonymous_user': '匿名用戶',
  'status_pending': '待發放',
  'status_issued': '已發放',
  'status_failed': '發放失敗',
  'status_limit': '邀請達到上限',
  'status_error': '異常',
  'bind_title': '填寫邀請碼',
  'bind_subtitle': '輸入邀請碼即可獲得獎勵積分。',
  'bind_placeholder': '請輸入邀請碼',
  'bind_btn': '綁定邀請碼',
  'bind_code_required': '邀請碼不能為空',
  'bind_success': '邀請碼綁定成功！',
  'bind_failed': '綁定邀請碼失敗，請重試',
  'bind_already_bound': '已綁定邀請碼，不能重複綁定',
  'bind_already_bound_user': '已綁定用戶邀請碼，不能重複綁定',
  'bind_already_bound_channel': '已綁定渠道邀請碼，不能重複綁定',
  'no_records': '暫無記錄',
  'share_text': 'PAITEAMS 邀請你註冊領積分！快來加入吧！'
}
